import { render, staticRenderFns } from "./ReminderBlocklistView.vue?vue&type=template&id=1311154a&scoped=true&"
import script from "./ReminderBlocklistView.vue?vue&type=script&lang=js&"
export * from "./ReminderBlocklistView.vue?vue&type=script&lang=js&"
import style0 from "./ReminderBlocklistView.vue?vue&type=style&index=0&id=1311154a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311154a",
  null
  
)

export default component.exports